export const news = {
  articles: '記事',
  notice: 'お知らせ',
  events: 'イベント',
  searchPlaceholder: '検索...',
  allCategories: 'すべてのカテゴリー',
  readMore: '続きを読む'
};

export default news;
